<template>
  <div v-if="loadingCheck">
    <div class="loading-container">
      <b-spinner variant="white"></b-spinner>
      <h4>{{ loadingMessage }}</h4>
      <p>از صبر و شکیبایی شما سپاسگزاریم</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TheLoading",
  data() {
    return {
      loading: null,
    };
  },
  computed: {
    ...mapState({
      loadingCheck: "loadingCheck",
      loadingMessage: "loadingMessage",
    }),
  },
};
</script>
